"use strict";

(() => {
    class ClickStream {
            
        initOnReady(){
            if(!window.dataLayer) return;
            
            this.buildSelectors();
            this.run();
            this.addEventClass();
            this.initEvents();
        }

        initOnLoad(){
            this.addEventClass();
            this.sendEvents();
            this.collectLoginSignupData();
        }

        buildSelectors(){
            this.selectors = this.selectors || {}; 
            this.selectors.isCartPage = document.querySelector('body.page--cart');
            this.selectors.isPDPPage = document.querySelector('body.page--product');
            this.selectors.isArticlePage = document.querySelector('body.page--article');
            this.selectors.loginForms = Array.from(document.querySelectorAll('form[action="/account/login"]'));
            this.selectors.registerForms = Array.from(document.querySelectorAll('form[action="/account"]'));

            this.selectors.registerSubmitError = document.querySelector('.event_profile_register_submit_error');
            this.selectors.loginSubmitError = document.querySelector('.event_profile_login_submit_error');
            this.selectors.atcForm = document.querySelector('.product_form form[action="/cart/add"]');
            this.selectors.setPswdError = document.querySelector('.event_profile_set_password_error');
            this.selectors.setPswdSuccess = document.querySelector('.event_profile_change_password_complete');

            this.selectors.allBtns = document.querySelectorAll('button, [role="button"]');
            this.selectors.menuItems = document.querySelectorAll('[data-nav-title]');
            this.selectors.allImages = document.querySelectorAll('img');
            this.selectors.homePageBannerLink = document.querySelectorAll('.banner.homepage-slideshow .banner-full-link');
            this.selectors.checkoutNowBtns = document.querySelectorAll('.event_checkout_now');
            this.selectors.continueShoppingBtns = document.querySelectorAll('.event_continue_shopping');
            this.selectors.profileRegisterBtns = document.querySelectorAll('.event_profile_register,.event_profile_register_view_form');
            this.selectors.profileUpdateBtns = document.querySelectorAll('.event_profile_update');
            this.selectors.registerSubmitBtns = document.querySelectorAll('.event_profile_register_submit');
            this.selectors.profileLoginBtns = document.querySelectorAll('.event_profile_login');
            this.selectors.profileLoginSubmitBtns = document.querySelectorAll('.event_profile_login_submit');
            this.selectors.profileUpdateSubmitBtns = document.querySelectorAll('.event_profile_update_submit');
            this.selectors.commentForms = document.querySelectorAll('.event_commen');
            this.selectors.commentSubmitBtns = document.querySelectorAll('.event_comment_submit');
            this.selectors.articleLinks = document.querySelectorAll('[href*="/blogs/"]');
            this.selectors.productLinks = document.querySelectorAll('[href*="/products/"]');
        }

        run(){
            const customerForms = this.selectors.loginForms.concat(this.selectors.registerForms);
            customerForms.forEach(form => {
                const returnURLInput = form.querySelector('input[name="return_url"]');
                if(returnURLInput) returnURLInput.remove();
            });
        }

        addEventClass(){
            if(this.selectors.isPDPPage && _theme.productJson){
                const barcode = _theme.productJson.current_variant.barcode || _theme.productJson.id;
                const ratingElem = document.querySelector('[data-bv-show="rating_summary"]');
                if(ratingElem && barcode){
                    ratingElem.classList.add('event_product_review_view');
                    ratingElem.classList.add('event_product_review');
                    ratingElem.setAttribute('data-action-detail', _theme.productJson.current_variant.barcode);
                }
            }

            this.selectors.menuItems.forEach(function(menu){
                let item = menu;
                if(menu.nodeName !== "A") item = menu.closest('a') ? menu.closest('a') : menu;
                const linkText = item.textContent ? item.textContent.trim() : '';
                item.classList.add('event_menu_click');
                item.setAttribute('data-action-detail', linkText);
            });

            this.selectors.allBtns.forEach(function(btn){
                if(btn.className.includes('event_')) return;
                const btnText = btn.textContent ? btn.textContent.trim() : '';
                btn.classList.add('event_button_click');
                btn.setAttribute('data-action-detail', btnText);
            });

            this.selectors.allImages.forEach(function(img){
                if(img.className.includes('event_')) return;
                img.classList.add('event_image_click');
            });

            this.selectors.homePageBannerLink.forEach(function(bnr){
                if(bnr.className.includes('event_')) return;
                bnr.classList.add('event_banner_click');
                bnr.setAttribute('data-action-detail', bnr.getAttribute('aria-label'));
            });

            this.selectors.articleLinks.forEach(function(link){
                if(link.className.includes('event_')) return;
                link.classList.add('event_view_article_page');
            });

            this.selectors.productLinks.forEach(function(link){
                if(link.className.includes('event_')) return;
                link.classList.add('event_view_product_detail_page');
            });
        }

        collectLoginSignupData(){
            const _url = new URL(window.location.href);
            const hasLoginParam = _url.searchParams.get('login');
            const hasSignupParam = _url.searchParams.get('signup');
  
            const trackLogin = sessionStorage.getItem('t_login');
            const trackSignup = sessionStorage.getItem('t_signup');
            const logOutLinks = document.querySelectorAll('a[href="/account/logout"]');

            if(!_theme.customerInfo) {
                sessionStorage.removeItem('t_login');
                sessionStorage.removeItem('t_signup');
                if(trackLogin || trackSignup){
                    _theme.sendClickStremEvent('CRM Profile Logout', {
                        label: "User logged out",
                    });
                }
                return;
            }

            logOutLinks.forEach(link => {
                link.addEventListener('click', evt => {
                    evt.preventDefault();
                    _theme.sendClickStremEvent('CRM Profile Logout', {
                        label: "User logged out",
                    });
                    setTimeout(() => {
                        window.location.href = '/account/logout'
                    }, 250);
                });
            });

            if(hasLoginParam){
                sessionStorage.setItem('t_login', true);
                // _url.searchParams.delete('login');
                // history.replaceState(null, '', _url.toString());
                
                _theme.segmentIdentify({
                    id: _theme.customerInfo.id,
                    name: _theme.customerInfo.fullName,
                    email: _theme.customerInfo.email,
                    city: _theme.customerInfo.cityName,
                });

                _theme.sendClickStremEvent('Website Login', {
                    email: _theme.customerInfo.email,
                    userId: _theme.customerInfo.id
                });
            }

            if(hasSignupParam){
                sessionStorage.setItem('t_signup', true);
                // _url.searchParams.delete('signup');
                // history.replaceState(null, '', _url.toString());

                _theme.segmentIdentify({
                    id: _theme.customerInfo.id,
                    name: _theme.customerInfo.fullName,
                    email: _theme.customerInfo.email,
                    city: _theme.customerInfo.cityName,
                });

                _theme.sendClickStremEvent('CRM Registration Complete', {
                    email: _theme.customerInfo.email,
                    userId: _theme.customerInfo.id
                });
            }
        }

        sendEvents(){
            if(this.selectors.isCartPage){
                _theme.sendClickStremEvent('Cart Viewed', {
                    total_amount: _theme.cartjson.total_price,
                    total_items: _theme.cartjson.item_count
                });
            }
            
            if(this.selectors.isPDPPage && _theme.productJson){
                _theme.sendClickStremEvent('Product Viewed', {
                    "brand": _theme.productJson.vendor,
                    "category": "",
                    "gtin": _theme.productJson.current_variant.barcode,
                    "id": _theme.productJson.id,
                    "name": _theme.productJson.title,
                    "price": _theme.productJson.price,
                    "productImage": _theme.productJson.featured_image,
                    "sku": _theme.productJson.current_variant.sku || _theme.productJson.id,
                    "upc": _theme.productJson.current_variant.barcode
                });

                if(!_theme.productJson.available){
                    _theme.sendClickStremEvent('Purchase Intent Out of Stock', {
                        "brand": _theme.productJson.vendor,
                        "category": "",
                        "gtin": _theme.productJson.current_variant.barcode,
                        "id": _theme.productJson.id,
                        "name": _theme.productJson.title,
                        "price": _theme.productJson.price,
                        "productImage": _theme.productJson.featured_image,
                        "sku": _theme.productJson.current_variant.sku || _theme.productJson.id,
                        "upc": _theme.productJson.current_variant.barcode
                    });
                }
            }

            if(this.selectors.registerSubmitError){
                const errorMsg = this.selectors.registerSubmitError.dataset.actionDetail || 'Error while register';
                _theme.sendClickStremEvent('CRM Registration Submit Error', {
                    label: errorMsg,
                });
            }

            if(this.selectors.loginSubmitError){
                const errorMsg = this.selectors.loginSubmitError.dataset.actionDetail || 'Error while login';
                _theme.sendClickStremEvent('CRM Profile Login Submit Error', {
                    label: errorMsg,
                });
            }

            if(this.selectors.setPswdError){
                const errorMsg = this.selectors.setPswdError.dataset.actionDetail || 'Error while reset password';
                _theme.sendClickStremEvent('CRM Profile Set Password Error', {
                    label: errorMsg.trim(),
                });
            }

            if(this.selectors.setPswdSuccess){
                const successMsg = this.selectors.setPswdSuccess.dataset.actionDetail || 'Password updated successfully';
                _theme.sendClickStremEvent('CRM Profile Set Password Complete', {
                    label: successMsg.trim(),
                });
            }

            if(this.selectors.isArticlePage){
                _theme.sendClickStremEvent('View article', _theme.articleJson);
            }
        }

        initEvents(){
            const productReviewView = document.querySelector('.event_product_review_view');
            const allBtns = document.querySelectorAll('button, [role="button"]');
            const menuBtns = document.querySelectorAll('.event_menu_click');
            const allImages = document.querySelectorAll('.event_image_click');

            if(this.selectors.atcForm && _theme.productJson) {
                this.selectors.atcForm.addEventListener('click', (evt) => {
                    const isBuyNow = evt.target.closest('[data-shopify="payment-button"]');
                    if(!isBuyNow) return;

                    _theme.sendClickStremEvent('Buy-it-now click-thru', {
                        "brand": _theme.productJson.vendor,
                        "category": "",
                        "gtin": _theme.productJson.current_variant.barcode,
                        "id": _theme.productJson.id,
                        "name": _theme.productJson.title,
                        "price": _theme.productJson.price,
                        "productImage": _theme.productJson.featured_image,
                        "sku": _theme.productJson.current_variant.sku || _theme.productJson.id,
                        "upc": _theme.productJson.current_variant.barcode
                    });
                });
            }

            this.selectors.checkoutNowBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('Checkout Started', {
                        total_amount: _theme.cartjson.total_price,
                        total_items: _theme.cartjson.item_count
                    }); 
                });
            });

            this.selectors.continueShoppingBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('Purchase Intent Continue Shopping', {
                        label: 'Clicked continue shopping button',
                    });
                })
            });

            this.selectors.profileRegisterBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('CRM Registration Intent', {
                        label: 'View signup page',
                    });
                });
            });

            this.selectors.profileUpdateBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('CRM Profile Change Password Complete', {
                        label: 'Password updated'
                    });
                });
            });

            this.selectors.registerSubmitBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('CRM Registration Submit', {
                        label: 'Create account'
                    });
                });
            });

            this.selectors.profileLoginBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('CRM Profile Login Intent', {
                        label: 'View Login Page',
                    });
                });
            });

            this.selectors.profileLoginSubmitBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('CRM Profile Login Submit', {
                        label: 'Submit login request'
                    });
                });
            });

            this.selectors.profileUpdateSubmitBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('CRM Profile Update Submit', {
                        label: 'update Address',
                    });
                });
            });

            allBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('Button Click', {
                        label: "Button clicked",
                        value: btn.textContent
                    });
                });
            });

            menuBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('Menu Click', {
                        label: "Menu clicked",
                        value: btn.dataset.actionDetail || btn.textContent
                    });
                });
            });

            allImages.forEach(img => {
                img.addEventListener('click', evt => {
                    _theme.sendClickStremEvent('Image Click', {
                        label: "Image clicked",
                        value: img.dataset.actionDetail || img.alt || ''
                    });
                });
            });

            if(productReviewView){
                productReviewView.addEventListener('click', evt => {
                    const productId = productReviewView.dataset.bvProductId;
                    const barcode = productReviewView.dataset.actionDetail;
                    _theme.sendClickStremEvent('View Posted Review', {
                        label: barcode || '',
                        value: productId || ''
                    });
                });
            }

            this.selectors.commentForms.forEach(form => {
                form.addEventListener('focusin', evt => {
                    _theme.sendClickStremEvent('User Generated Content Comment Intent', {
                        label: form.dataset.title || '',
                        value: form.dataset.actionDetail || ''
                    });
                }, {once: true})
            });

            this.selectors.commentSubmitBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    const form = btn.closest('form');
                    if(!form) return;

                    _theme.sendClickStremEvent('User Generated Content Comment Submitted', {
                        label: form.dataset.title || '',
                        value: form.dataset.actionDetail || ''
                    });
                }, {once: true})
            });

            window.onbeforeunload = function(){
                _theme.sendClickStremEvent('Close Window', {
                    label: document.title,
                    value: window.location.href
                });
            }
        }
    }

    const clickstream = new ClickStream();
    document.addEventListener('DOMContentLoaded', () => {
        clickstream.initOnReady();
        const segmentInterval = window.setInterval(() => {
            if(window.analytics && window.dataLayer) {
                clearInterval(segmentInterval);
                clickstream.initOnLoad();
            }
        }, 250);

        setTimeout(() => {
            clearInterval(segmentInterval);
        }, 10000);
    });
})();